<div class="content">
  <h1>Willkommen bei Seeguide.at</h1>
  
  <div class="categories row">
    
    <div class="col-sm-6 col-lg">
      <div class="card ratio">
        <a routerLink="/badeplaetze">
          <picture>
            <source
              srcset="/assets/badeplaetze-min.jpg"
              media="(max-width: 599.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/badeplaetze-mid.jpg"
              media="(min-width: 600px) and (max-width: 959.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/badeplaetze.jpg"
              media="(min-width: 960px)"
              type="image/jpg"/>
            <img src="/assets/badeplaetze.jpg" width="800" height="600" alt="Bild Schönste Badeplätze am Attersee" />
          </picture>
          <div class="category-name">
            Badeplätze
          </div>
        </a>
      </div>
    </div>
  
    <div class="col-sm-6 col-lg">
      <div class="card ratio">
        <a routerLink="/restaurants">
          <picture>
            <source
              srcset="/assets/restaurants-min.jpg"
              media="(max-width: 599.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/restaurants-mid.jpg"
              media="(min-width: 600px) and (max-width: 959.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/restaurants.jpg"
              media="(min-width: 960px)"
              type="image/jpg"/>
            <img src="/assets/restaurants.jpg" width="700" height="951" alt="Bild Top Restaurants am Attersee" />
          </picture>
          <div class="category-name">
            Restaurants
          </div>
        </a>
      </div>
    </div>
  
    <div class="col-sm-6 col-lg">
      <div class="card ratio">
        <a routerLink="/ausfluege">
          <picture>
            <source
              srcset="/assets/ausfluege-min.jpg"
              media="(max-width: 599.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/ausfluege-mid.jpg"
              media="(min-width: 600px) and (max-width: 959.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/ausfluege.jpg"
              media="(min-width: 960px)"
              type="image/jpg"/>
            <img src="/assets/ausfluege.jpg" width="800" height="600" alt="Bild Schönsten Wanderungen rund um den Attersee" />
          </picture>
          <div class="category-name">
            Ausflüge
          </div>
        </a>
      </div>
    </div>

    <div class="col-sm-6 col-lg">
      <div class="card ratio">
        <a routerLink="/unterkuenfte">
          <picture>
            <source
              srcset="/assets/hotel-min.jpg"
              media="(max-width: 599.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/hotel-mid.jpg"
              media="(min-width: 600px) and (max-width: 959.99px)"
              type="image/jpg"/>
            <source
              srcset="/assets/hotel.jpg"
              media="(min-width: 960px)"
              type="image/jpg"/>
            <img src="/assets/hotel.jpg" width="800" height="600" alt="Bild Besten Unterkünfte rund um den Attersee" />
          </picture>
          <div class="category-name">
            Unterkünfte
          </div>
        </a>
      </div>
    </div>
    </div>

  <div class="text">
    <p class="download"><strong>Jetzt kostenlos Seeguide.at App herunterladen!</strong>
      
    </p>
    <div class="badges">
      <div class="appstore">
        <a href="https://apps.apple.com/at/app/id1529068241"><img src="/assets/appstorebadge.svg" alt="appstore badge"></a>
      </div>
      <div class="playstore">
        <a href="https://play.google.com/store/apps/details?id=at.seeguide.app"><img src="/assets/google-play-badge.svg" alt="playstore badge"></a>
      </div>
    </div>
    

    <p>Hier findest du alles rund um den Attersee. Neben allen Badeplätzen sind auch viele ausgewählte Restaurants bei uns gelistet und mit entsprechenden Bildern und Bewertungen versehen.</p> 
    <p>Oben kannst du zwischen den verschiedenen Kategorien auswählen.</p>

    <p>Außerdem solltest du dir unser Seeguide App herunterladen. Dort gibt es neben einer tollen übersichtlichen Kartenansicht auch ein Forum mit vielen Geheimtipps.</p>
    
    <p>In der App kannst du auch Bewertungen zu den Badeplätzen und Restaurants abgeben und Fotos hochladen, wenn du diese mit der Community teilen möchtest.</p>
    
    <p>Wir wünschen viel Spaß beim Stöbern.</p>
    <br>
    
  </div>
  
  
  
</div>
